import { UseQueryOptions } from 'react-query';
import { useQuery } from '@frontend/react-query-helpers';
import { PhoneNumberSchemaService, SchemaIO } from '@frontend/schema';

export const queryKeys = {
  base: ['calls'] as const,
  outboundNumbers: (tenantId: string) => [...queryKeys.base, 'outbound-voice-numbers', tenantId],
  getNumbersBySipProfileId: (sipProfileId: string) => [...queryKeys.base, 'outbound-caller-numbers', sipProfileId],
};

type Req = SchemaIO<typeof PhoneNumberSchemaService.ListVoicePhoneNumbers>['input'];
type Res = SchemaIO<typeof PhoneNumberSchemaService.ListVoicePhoneNumbers>['output']['response'];
export const useVoiceNumbersQuery = (tenantId?: string, options: UseQueryOptions<Res, Req> = {}) => {
  return useQuery({
    queryKey: queryKeys.outboundNumbers(tenantId ?? ''),
    queryFn: () => PhoneNumberSchemaService.ListVoicePhoneNumbers({ tenantId }).then((res) => res.response),
    ...options,
  });
};
